import { useMutation, useQueryClient } from '@tanstack/react-query';
import { QUERY_KEYS_ENUM } from '../../static/query-keys.enum';
import { useToastMessage } from '../useQueryHelper';
import { handleAxiosError } from '../../api/error-handler/error-handler';
import { resolveComment } from '../../api/checker-maker';

export const useResolveComment = () => {
  const { openToast } = useToastMessage();
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: [QUERY_KEYS_ENUM.resolveComment],
    mutationFn: resolveComment,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS_ENUM.getCommentList] });
      openToast({ label: 'Sukses menyelesaikan komentar' });
    },
    onError: (error) => {
      const message = handleAxiosError(error);
      openToast({ label: message, isError: true });
    }
  });
};
